import './style.scss';
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from 'react';
import { Link, useParams } from "react-router-dom";

import VisualGrid from "../../components/VisualGrid";
import HeaderMenu from "../../components/Header-Menu";
import Footer from "../../components/Footer";

function App() {
  return (
    <div className="mc-score">
      <VisualGrid />        
      <section className="mc-score__content">
        <HeaderMenu />
        <section className="mc-score__score-wrap">
          <div className="container">
            <p className="video-label">
              ORIGINAL MOTION PICTURE SOUNDTRACK | MAIN TITLE THEME
            </p>               
            <div className="video">
              <div className="iframe-container">
                <iframe src="https://www.youtube.com/embed/z9CrkOQoQHg?si=RJyM30vAUhtamctp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>            
          </div>        
        </section>
        <section className="mc-score__composer">
          <div className="container">
            <div className="name">
              <span>JEROEN MANDERS</span>, The Composer
            </div>        
            <div className="snippet">
              <p>"I very deliberately wanted it to sound classical, so it would naturally evoke regency and power. Brass became the obvious choice, as those instruments have always embodied royalty, authority, bravery, and heroism, especially when reinforced by drums. The strings, to me, are the orchestra's bloodstream, providing its pulse and continuous flow, while the percussion adds structure and skin, holding everything together."</p>
              <div className="links">
                <a href="https://soundcloud.com/jeroen-manders-3" target="_blank">
                  <i className="fa fa-soundcloud" aria-hidden="true"></i>
                  &nbsp; Soundcloud
                </a>
                {/*
                <a href="https://jeroenmanders.com" target="_blank">
                  <i className="fa fa-globe" aria-hidden="true"></i>
                  &nbsp; Website
                </a>
                */}
              </div>
            </div>
          </div>
        </section>
        <section className="mc-score__photos">
          <div className="container">
            <div className="image-wrap notes">
              <img src="/images/jeroren-notes-2.png" />
            </div>
            <div className="image-wrap piano">
              <img src="/images/jeroen-room.png" />
            </div>
          </div>
        </section>         
      </section>      
      <Footer />
    </div>
  );
}

export default App;